/**
 * @generated SignedSource<<968b569d806391bf310648897168fa30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeIncrementsSection_company$data = {
  readonly timeRegistrationSettings: {
    readonly id: string;
    readonly granularity: string | null;
  } | null;
  readonly " $fragmentType": "TimeIncrementsSection_company";
};
export type TimeIncrementsSection_company$key = {
  readonly " $data"?: TimeIncrementsSection_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeIncrementsSection_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeIncrementsSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeRegistrationSettingsType",
      "kind": "LinkedField",
      "name": "timeRegistrationSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "granularity",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "a55f4f18f596c13ba7496de78a2f40c8";

export default node;
